import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

import { ILoggedInProfile, IAuthStore } from "../../types/EC/auth/profile";

const authStore = (set: any) => ({
  profileData: {
    email: "",
    name: "",
    role: "",
    avatar: "",
    _id: "",
    isAuth: false,
  },

  setProfileData: (loggedInProfileData: ILoggedInProfile) =>
    set((state: IAuthStore) => ({
      profileData: {
        ...state.profileData,
        ...loggedInProfileData,
        isAuth: true,
      },
    })),

  setProfileDataEmpty: () =>
    set((state: IAuthStore) => ({
      ...state,
      profileData: {},
    })),
});

const useAuthStore = create(
  devtools(
    persist(authStore, {
      name: "authStore",
    })
  )
);

export default useAuthStore;
